import React from "react";

const DashboardFilterBar = ({
  searchTerm,
  setSearchTerm,
  selectedType,
  setSelectedType,
  selectedStatus,
  setSelectedStatus,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  availableTypes,
  onClear,
  onExport,
}) => {
  const formatDate = (date) =>
    date ? date.toISOString().split("T")[0] : "";

  return (
    <div className="flex flex-col md:flex-row md:items-end gap-4">
      <input
        type="text"
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="border rounded px-2 py-1 text-sm"
      />

      <select
        value={selectedType}
        onChange={(e) => setSelectedType(e.target.value)}
        className="border rounded px-2 py-1 text-sm"
      >
        <option value="">All Types</option>
        {availableTypes.map((type) => (
          <option key={type.value} value={type.value}>
            {type.label}
          </option>
        ))}
      </select>

      <select
        value={selectedStatus}
        onChange={(e) => setSelectedStatus(e.target.value)}
        className="border rounded px-2 py-1 text-sm"
      >
        <option value="">All Statuses</option>
        <option value="Approved">Approved</option>
        <option value="Pending">Pending</option>
        <option value="Rejected">Rejected</option>
        <option value="Canceled">Canceled</option>
      </select>

      <div className="flex flex-col">
        <label className="text-sm text-gray-600">Start Date</label>
        <input
          type="date"
          value={formatDate(startDate)}
          onChange={(e) => setStartDate(e.target.value ? new Date(e.target.value) : null)}
          className="border rounded px-2 py-1 text-sm"
        />
      </div>

      <div className="flex flex-col">
        <label className="text-sm text-gray-600">End Date</label>
        <input
          type="date"
          value={formatDate(endDate)}
          onChange={(e) => setEndDate(e.target.value ? new Date(e.target.value) : null)}
          className="border rounded px-2 py-1 text-sm"
        />
      </div>

      <button
        onClick={onClear}
        className="bg-gray-300 text-gray-700 px-3 py-1.5 rounded shadow hover:bg-gray-400 transition"
      >
        Clear Filter
      </button>

      <button
        onClick={onExport}
        className="bg-blue-500 text-white px-4 py-2 rounded shadow hover:bg-blue-600 transition"
      >
        Export to Excel
      </button>
    </div>
  );
};

export default DashboardFilterBar;
